import React from 'react';

// state
import { useAppSelector } from '../../../store/hooks';
import {} from '../../../service/api/report';

// components
import MiniButton from '../../../components/elements/forms/MiniButton';
import RichTextInputBox from '../../../components/elements/forms/RichTextInputBox';

type IUpdateReportSourcing = {
	onSubmit: (data: string) => void;
};

const UpdateReportSourcing: React.FC<IUpdateReportSourcing> = ({
	onSubmit
}) => {
	const [show, showSet] = React.useState<boolean>();
	const [data, dataSet] = React.useState<string>('');
	const report_stats = useAppSelector(({ report }) => report.report_stats);

	const onLoad = React.useCallback(() => {
		if (report_stats?.sourcing) dataSet(report_stats?.sourcing);
	}, [report_stats?.sourcing]);

	React.useEffect(() => {
		onLoad();
	}, [onLoad]);

	return (
		<div>
			<div>
				{!show ? (
					report_stats?.sourcing ? (
						<div
							dangerouslySetInnerHTML={{
								__html: report_stats.sourcing
							}}
						/>
					) : (
						<div />
					)
				) : (
					<RichTextInputBox
						value={data}
						placeholder="Enter Sourcing"
						status=""
						onChange={(e) => dataSet(e)}
					/>
				)}
			</div>
			<div>
				<div className="w-full flex justify-end my-2">
					<div className="w-[15%]">
						<MiniButton
							title={!show ? 'Edit' : 'Update'}
							onHandler={() => {
								if (show) {
									onSubmit(data);
									showSet(false);
								} else {
									showSet(true);
								}
							}}
							backgroundColor="#CDD8FE"
							textColor="#243677"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdateReportSourcing;
